import {
  Avatar,
  Text,
  Box,
  useDisclosure,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Tooltip,
  Spinner,
} from '@chakra-ui/react';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  FaHeart,
  FaPen,
  FaRegComment,
  FaRegHeart,
  FaShareAlt,
  FaFlag,
  FaCaretDown,
  FaCaretUp,
  FaDotCircle,
} from 'react-icons/fa';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { mutateFunction } from '../../libs/apis';
import CreateCommentModal from '../modal/CreateCommentModal';
import ShareContentModal from '../modal/ShareContentModal';
import { CustomToast } from '../toast/CustomToast';
import MediaDisplay from './MediaDisplay';
import ShareContent from './ShareContent';
import { useSelector } from 'react-redux';
import { WarningTwoIcon } from '@chakra-ui/icons';
import { FaTrash } from 'react-icons/fa';
import { useQueryClient } from 'react-query';
import EditPostModal from '../modal/EditPostModal';
import DeletePostModal from '../modal/DeletePostModal';
import { FaEllipsisV } from 'react-icons/fa';
import userSlice from '../../redux-toolkit/reducers/userSlice';
import ReportPostModal from '../modal/ReportPostModal';
import ReactionUsers from './ReactionUsersModal';
import { BASE_URL } from '../../helpers/constant';
import client from '../../libs/client';
import Comment from './Comment';
import useData from '../../data/useData';
import PostTextDisplay from './PostTextDisplay';
import { HeartFilled } from '@ant-design/icons';
import ReactionDisplay from './ReactonDisplay';
import InPostComment from './InPostComment';
import CreateComment from './CreateComment';

const Post = ({ post, refetchPost = () => {}, postId = null }) => {
  const userInfo = useSelector((state) => state?.user?.userInfo);
  const [_post, setPost] = useState(post);
  const { mutate, isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const navigate = useNavigate();

  const {
    isOpen: createCommentModalIsOpen,
    onClose: onCloseCreateCommentModal,
    onOpen: onOpenCreateCommentModal,
  } = useDisclosure();
  const {
    isOpen: createShareContentIsOpen,
    onClose: onCloseShareContent,
    onOpen: onOpenShareContent,
  } = useDisclosure();
  const {
    isOpen: editPostIsOpen,
    onClose: onCloseEditPost,
    onOpen: onOpenEditPost,
  } = useDisclosure();

  const {
    isOpen: deletePostIsOpen,
    onClose: onCloseDeletePost,
    onOpen: onOpenDeletePost,
  } = useDisclosure();

  const {
    isOpen: reportPostIsOpen,
    onClose: onCloseReportPost,
    onOpen: onOpenReportPost,
  } = useDisclosure();

  const {
    isOpen: reactionUsersIsOpen,
    onClose: onCloseReactionUsers,
    onOpen: onOpenReactionUsers,
  } = useDisclosure();

  const [latestReactionUser, setLatestReactionUser] = useState(
    post?.latestReactionUser || null,
  );
  const [isLiked, setIsLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [commentsCount, setCommentsCount] = useState(0);
  const [message, setMessage] = useState('');
  const [link, setLink] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const queryClient = useQueryClient();
  const [isLoadingPost, setIsLoadingPost] = useState(false);
  const [isNestedComment, setIsNestedComment] = useState(false);
  const [reactionUsers, setReactionUsers] = useState([]);
  // const [isLoadingComments, setIsLoadingComments] = useState(false);
  const [comments, setComments] = useState([]);

  const {
    data: reactionUsersData,
    isLoading: reactionUsersLoading,
    refetch: refetchReactionUsers,
  } = useData(`react/post/users?post_id=${_post.id}`, 30000, {}, 1, false);

  useEffect(() => {
    if (reactionUsersData) {
      setReactionUsers(reactionUsersData?.data?.reactionUsers);
    }
  }, [reactionUsersData]);

  const {
    isOpen: showCommentsIsOpen,
    onClose: onCloseShowComments,
    onOpen: onOpenShowComments,
    onToggle: onToggleShowComments,
  } = useDisclosure({ defaultIsOpen: !!postId });

  const [visibleCount, setVisibleCount] = useState(3);

  const handleShowMore = (e) => {
    e.stopPropagation();
    setVisibleCount((prev) => prev + 10);
  };

  const handleShowLess = (e) => {
    e.stopPropagation();
    setVisibleCount(3);
  };

  const goToPost = (e) => {
    e.stopPropagation();
    navigate(`/post?id=${_post.id}`);
  };

  const likePost = () => {
    try {
      mutate(
        {
          key: 'react/post',
          method: 'post',
          data: {
            post_id: _post.id,
            comment_id: null,
          },
        },
        {
          onSuccess(res) {
            // addToast(res);
            refetchPost();
            // isLiked
            //   ? setLikesCount((prev) => prev - 1)
            //   : setLikesCount((prev) => prev + 1);
            // setIsLiked((prev) => !prev);
          },
          onError(e) {
            // addToast({message: 'Post was not liked'}, "error")
            console.error(e);
          },
        },
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (post) {
      setPost(post);
    }
  }, [post]);

  useEffect(() => {
    setIsLiked(_post.isLiked);
    setLikesCount(_post.likes_count);
    setLatestReactionUser(_post.latestReactionUser);
    setCommentsCount(_post.comment_count);
    const _message = `Hi! ${_post.user.first_name} ${_post.user.last_name} shared their thoughts on SeedAFounder`;
    const _link = `${process.env.REACT_APP_FRONTEND_URL}public/posts?id=${_post.id}`;
    setMessage(_message);
    setLink(_link);
  }, [_post]);

  // const onCreateComment = (comment) => {
  //   // setCommentsCount((prev) => prev + 1);
  //   // setComments((prev) => [comment, ...prev]);
  // };

  const viewProfileDetails = (e) => {
    e.stopPropagation();
    if (post?.user_id === userInfo?.id) {
      navigate('../account-settings');
    } else {
      const userType = post?.user?.user_type_id;
      const userId = post?.user_id;
      navigate(`../view-user?userid=${userId}&usertype=${userType}`);
    }
  };

  const deletePost = async () => {
    mutate(
      {
        key: `post/${post?.id}`,
        method: 'delete',
      },
      {
        onSuccess(res) {
          addToast(res);
          // queryClient.invalidateQueries(`feed?postId=${postId}`);
          refetchPost();
          onCloseDeletePost();
        },
        onError: (err) => {
          addToast(
            err?.response?.data?.message || 'Error deleting post',
            'error',
          );
        },
      },
    );
  };

  const onEditPost = async (post) => {
    setPost((prev) => ({
      ...prev,
      ...post,
    }));
  };

  const {
    data: commentsData,
    isLoading: isLoadingComments,
    refetch: refetchComments,
  } = useData(`comment/post/${_post.id}`, 3000);

  useEffect(() => {
    if (commentsData) {
      setComments(commentsData?.data?.comments);
      if (!showCommentsIsOpen) {
        onToggleShowComments();
      }
    }
  }, [commentsData?.data?.comments]);

  const loadComments = async (e) => {
    e.stopPropagation();
    if (comments.length == 0 && !showCommentsIsOpen) {
      refetchComments();
    }
    onToggleShowComments();
  };

  return (
    <Box className="w-full flex cursor-pointer items-start gap-2 ">
      {/* <CreateCommentModal
        isOpen={createCommentModalIsOpen}
        onClose={onCloseCreateCommentModal}
        post={post}
        onSuccess={refetchComments}
        refetchPost={refetchPost}
      /> */}
      <ShareContentModal
        isOpen={createShareContentIsOpen}
        onClose={onCloseShareContent}
        message={message}
        link={link}
        subject={'Hello! Check out this post on SeedAFounder.'}
      />

      <DeletePostModal
        isOpen={deletePostIsOpen}
        onClose={onCloseDeletePost}
        isLoading={isLoading}
        deletePost={deletePost}
      />

      <EditPostModal
        post={post}
        isOpen={editPostIsOpen}
        onClose={onCloseEditPost}
        onSuccess={onEditPost}
      />

      <ReportPostModal
        isOpen={reportPostIsOpen}
        onClose={onCloseReportPost}
        post={post}
      />

      <ReactionUsers
        reactionUsers={reactionUsers}
        isVisible={reactionUsersIsOpen}
        onClose={onCloseReactionUsers}
        isLoading={reactionUsersLoading}
      />

      <Box className="w-full cursor-pointer flex  flex-col">
        <Box className="w-full px-4 pt-5 pb-5 min-h-10">
          <Box
            onClick={goToPost}
            className="flex items-start gap-4 justify-between"
          >
            <Box className="flex items-start gap-4">
              <Box className="cursor-pointer">
                <Avatar
                  onClick={viewProfileDetails}
                  src={_post.user.profile_image || null}
                  name={`${_post.user.first_name} ${_post.user.last_name}`}
                  size={'md'}
                />
              </Box>
              <Box className="flex flex-col mb-3">
                <Text
                    as="span"
                    className="font-semibold capitalize"
                    _hover={{
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      color: 'blue.600',
                    }}
                    onClick={viewProfileDetails}
                  >
                    {_post.user.first_name} {_post.user.last_name}
                  </Text>
                <Box className="flex flex-row items-center gap-1">
                  <Text className="text-xs text-gray-500">
                  {moment(_post.createdAt).fromNow()}
                </Text>

                  <FaDotCircle className="text-[7px]" />
                  <Text
                    as="span"
                    className="text-xs font-semibold  text-gray-600 capitalize"
                  >
                    {_post.user.user_type_id == 1
                      ? 'Founder'
                      : _post.user.user_type_id == 2
                        ? 'Investor'
                        : _post.user.user_type_id == 3
                          ? 'Expert'
                          : 'Member'}
                  </Text>
                </Box>
              </Box>
            </Box>

            <Box
              className="flex gap-2 items-center justify-center"
              onClick={(e) => e.stopPropagation()}
            >
              {post?.user_id === userInfo?.id && (
                <Menu>
                  <MenuButton
                    as={IconButton}
                    icon={<FaEllipsisV className="text-gray-600 mx-auto" />}
                    variant="unstyled"
                    size="sm"
                    aria-label="Post options"
                    className="hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition-all duration-200"
                    _active={{ bg: 'gray-200' }}
                    _hover={{ bg: 'gray-100' }}
                  />
                  <MenuList
                    className="shadow-xl border border-gray-100 rounded-xl py-1"
                    minW="200px"
                  >
                    {moment(post?.createdAt)
                      .add(2, 'hour')
                      .isAfter(moment()) && (
                      <MenuItem
                        icon={<FaPen className="text-gray-600" />}
                        onClick={(e) => {
                          e.stopPropagation();
                          onOpenEditPost();
                        }}
                        className="px-4 py-2.5 hover:bg-gray-50 transition-colors duration-150 font-medium"
                      >
                        Edit post
                      </MenuItem>
                    )}
                    <MenuItem
                      icon={<FaTrash className="text-gray-600" />}
                      onClick={(e) => {
                        e.stopPropagation();
                        onOpenDeletePost();
                      }}
                      className="px-4 py-2.5 hover:bg-gray-50 transition-colors duration-150 text-red-600 font-medium"
                    >
                      Delete post
                    </MenuItem>
                  </MenuList>
                </Menu>
              )}
            </Box>
          </Box>

          <PostTextDisplay _post={_post} />
        </Box>
        {_post.media.length > 0 ? <MediaDisplay media={_post.media} /> : null}
        {
          likesCount > 0 ? (
          <Box className="w-full px-4 py-3">
            <ReactionDisplay
              latestReactionUser={latestReactionUser}
              likesCount={likesCount}
              onClickReactionUsers={() => {
                refetchReactionUsers();
                onOpenReactionUsers();
              }}
            />
          </Box>
          ) : null
        }
        <Box className="flex items-center text-sm pb-2 px-4 justify-between">
          <Box
            className="flex gap-1 cursor-pointer items-center"
          >
            <Box className="text-xs">
              👍
            </Box>
            <Text className="text-gray-700">{likesCount}</Text>
          </Box>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              if(createCommentModalIsOpen){
                onCloseCreateCommentModal();
              }else{
                onOpenCreateCommentModal();
              }
            }}
            className="flex gap-1 hover:underline cursor-pointer items-center"
          >
            <Text className="text-gray-700">{commentsCount} {commentsCount == 1 ? 'Comment' : 'Comments'}</Text>
          </Box>
        </Box>
        <Box className="flex items-center border-t p-3 px-4 border-gray-200 justify-around">
          <Box
            onClick={(e) => {
              e.stopPropagation();
              likePost();
            }}
            className="flex gap-2 cursor-pointer items-center"
          >
            <Box className="text-xl">
              👍
            </Box>
            <Text className="text-gray-700 hidden md:block">Like</Text>
          </Box>
          <Box
            onClick={(e) => {
              e.stopPropagation();
              if(createCommentModalIsOpen){
                onCloseCreateCommentModal();
              }else{
                onOpenCreateCommentModal();
              }
            }}
            className="flex gap-2 cursor-pointer items-center"
          >
            <FaRegComment className="text-gray-600" />
            <Text className="text-gray-700 hidden md:block">Comment</Text>
          </Box>

          <Tooltip
            label="Share post"
            placement="top"
            hasArrow
            bg="gray.700"
            color="white"
            fontSize="sm"
          >
            <Box
              onClick={(e) => {
                e.stopPropagation();
                onOpenShareContent();
              }}
              className="flex gap-2 cursor-pointer items-center"
            >
              <FaShareAlt />
            <Text className="text-gray-700 hidden md:block">Share</Text>

            </Box>
          </Tooltip>

          {post?.user_id !== userInfo?.id && (
            <Tooltip
              label="Report post"
              placement="top"
              hasArrow
              bg="gray.700"
              color="white"
              fontSize="sm"
            >
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  onOpenReportPost();
                }}
                className="flex gap-2 cursor-pointer items-center"
              >
                <FaFlag className="text-gray-600" />
            <Text className="text-gray-700 hidden md:block">Report</Text>

              </Box>
            </Tooltip>
          )}
        </Box>
        {
          createCommentModalIsOpen ? ( <>
            <Box className="w-full border-t border-gray-200 px-5 pt-3">
          <CreateComment 
          // isOpen={createCommentModalIsOpen}
            onClose={onCloseCreateCommentModal}
            post={post}
            onSuccess={refetchComments}
            refetchPost={refetchPost}
            showPost={false}
            showCloseButton={false}
            showReplyButton={false}
            showAltReplyButton={true}
        />
        </Box>
        {commentsCount > 0 ? (
          <Box className="hidden justify-end">
            <Box
              onClick={loadComments}
              className="flex items-center cursor-pointer hover:font-semibold gap-2"
            >
              <Text className="text-xs">
                {!showCommentsIsOpen ? 'Show' : 'Hide'} Comments
              </Text>
              {!showCommentsIsOpen ? <FaCaretDown /> : <FaCaretUp />}
            </Box>
          </Box>
        ) : null}
        {comments.length > 0 || isLoadingComments ? (
          <>
            <Box className="flex w-full flex-col max-w-2xl mx-auto my-5 gap-1">
              {isLoadingComments ? (
                <Box className="w-full flex justify-center">
                  <Spinner />
                </Box>
              ) : null}
              <>
                {comments.slice(0, visibleCount).map((comment) => {
                  return (
                    <Box className="px-2 bg-white" key={comment.id}>
                      <InPostComment
                        postLink={
                          comment?.replies_count > 0
                            ? `/post?id=${_post.id}&commentId=${comment.id}`
                            : `/post?id=${_post.id}`
                        }
                        parentId={post.id}
                        post={comment}
                        queryKey={`comment/post/${_post.id}`}
                        onCommentSuccess={() => {
                          refetchPost();
                          refetchComments();
                        }}
                      />
                    </Box>
                  );
                })}
                {visibleCount < comments.length && (
                  <Box className="flex w-full justify-end">
                    <Box
                      onClick={handleShowMore}
                      className="flex items-center cursor-pointer hover:font-semibold gap-2"
                    >
                      <Text className="text-xs">Show more</Text>
                      <FaCaretDown />
                    </Box>
                  </Box>
                )}
                {visibleCount >= comments.length && comments.length > 3 && (
                  <Box className="flex w-full justify-end">
                    <Box
                      onClick={handleShowLess}
                      className="flex items-center cursor-pointer hover:font-semibold gap-2"
                    >
                      <Text className="text-xs">Show Less</Text>
                      <FaCaretUp />
                    </Box>
                  </Box>
                )}
              </>
            </Box>
          </>
        ) : null}
          </>) : null
        }
      </Box>
    </Box>
  );
};

export default Post;
